// Limitless imports
import { TEXT_ENCODING, fetchPlatformResources } from "@limitless/common/apis/resource-api";
import { findContentResources } from "../../../manager/apis";
export const useExpertOnboardingContentHook = () => {
  const defaultResourceRequest = (groupProps, fileName) => {
    const {
      language,
      country,
      groupName,
      tenantName
    } = groupProps;
    return {
      tenantGroupOnly: true,
      ignoreCache: true,
      resourceList: [{
        name: fileName,
        applicationName: "onboarding",
        processor: TEXT_ENCODING,
        encoding: TEXT_ENCODING
      }],
      locale: `${language}-${country}`,
      groupName,
      tenantName,
      replaceFieldValue: false
    };
  };
  const fetchExpertOnboardingContent = (fileName, groupProps, successCallback, failureCallback) => {
    const resource = defaultResourceRequest(groupProps, fileName);
    fetchPlatformResources(resource, res => {
      var _res$, _res$$content;
      const {
        template = "",
        sections = []
      } = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : (_res$$content = _res$.content) === null || _res$$content === void 0 ? void 0 : _res$$content.content;
      if (template !== "" && sections.length > 0) {
        successCallback(template, sections);
      } else {
        failureCallback();
      }
    }, () => {
      failureCallback();
    });
  };
  const findContentResource = (fileName, groupProps, successCallback, failureCallback) => {
    var _resource$locale;
    const resource = defaultResourceRequest(groupProps, fileName);
    const options = {
      groupName: resource.groupName,
      tenantName: resource.tenantName,
      resourceName: fileName,
      encoding: "text",
      ignoreCache: true,
      baseLocation: "",
      folder: "",
      applicationName: "onboarding",
      tenantGroupOnly: true,
      fileName,
      locale: (_resource$locale = resource.locale) !== null && _resource$locale !== void 0 ? _resource$locale : "en-GB",
      shouldMergeContent: true,
      replaceFieldValue: true
    };
    findContentResources(options, response => {
      if (response) {
        var _response$data;
        if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.content) {
          var _response$data2;
          successCallback(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.content);
        } else {
          failureCallback();
        }
      }
    });
  };
  return {
    fetchExpertOnboardingContent,
    defaultResourceRequest,
    findContentResource
  };
};